// extracted by mini-css-extract-plugin
export default {"loaderSection":"loader_loaderSection__ASO-Q","loaderSecitionh1":"loader_loaderSecitionh1__a2DG4","lds_ring":"loader_lds_ring__Xofyo"};